// Blog index collection.
import { collectionSection, defineCollection, text } from '../schema';
export const blogCollection = defineCollection({
    id: 'collection:blog',
    kind: 'index',
    route: '/blog',
    title: 'Blog',
    description: 'Updates and insights from Airhead Games.',
    seo: {
        description: 'Updates and insights from Airhead Games. Read about new features, game announcements, industry insights, and tips for getting the most out of our party games.',
    },
    hero: {
        title: [text('Blog')],
        description: [text('Updates and insights from Airhead Games.')],
        background: 'gradient-card',
        backgroundAccentFamily: 'sky',
        showDescription: true,
    },
    sections: [
        collectionSection({
            id: 'posts',
            widgets: [
                {
                    type: 'documentList',
                    source: {
                        type: 'query',
                        kind: 'blog',
                        sortBy: 'publishedAt-desc',
                    },
                    layout: 'featured-grid',
                },
            ],
        }),
    ],
});
//# sourceMappingURL=blog.js.map